/** Request header sent when dev impersonation overlay is active — server blocks PA. */
export const PA_DEV_IMPERSONATION_HEADER = "x-dev-impersonation-active";
